export default __webpack_public_path__ + "static/media/box1.11f21a1f.svg";